<!--
  SettlementDetail.vue
  콜봇 월 정산 · 병원 상세(월 정산) 페이지(/callbot/settlement/:companyId?month=YYYY-MM&tab=settle|rates|recon|diag).
  화면 명세 2 — 공통 헤더(DetailHeader) + 탭 넷(정산 · 요율 · 대사 · 연결 진단).

  - 이 셸은 정산 상세(요청 계약 2 `GET .../billing/settlement?month=`) 하나만 부른다. 들어올 때와 병원·월이
    바뀔 때 부르고, 탭을 바꿀 때는 다시 부르지 않는다. 헤더와 정산·요율·대사 탭이 이 응답 하나를 같이 쓴다.
    탭마다 따로 필요한 호출(일회성 항목·예외·기본 요율·리포트 등)은 그 탭이 처음 열릴 때 스스로 한다.
  - 쓰기(예외 저장, 정산 저장·다시 계산·확정·재수정, 일회성 항목) 뒤에는 탭이 reload() 로 상세를 다시 받는다 —
    헤더와 탭이 함께 갱신된다. 다시 받는 동안에는 이전 상세를 그대로 보인다(detailLoading).
  - 병원·월이 바뀌면 이전 상세를 버린다 — 다른 달 숫자를 새 달 제목 아래 보이지 않게. 탭은 `companyId:month` 로
    키를 단 묶음 안 <KeepAlive> 에서 그려 병원·월마다 한 번만 마운트된다. 정산·요율·대사 탭은 첫 상세가 온
    뒤에 마운트되고, 연결 진단 탭은 상세를 쓰지 않아(리포트·통화 단건만 부른다) 상세를 기다리지 않는다.
  - 상세를 받는 중·받지 못함(미구현·오류·형식 오류)은 탭 바를 둔 채 정산·요율·대사 패널 안에 스켈레톤·안내로
    보인다. 상세가 실패해도 연결 진단 탭은 열린다.
  - 삭제된 회사도 다른 병원과 같다 — 정산 라우트·통화 1건 연결 확인·리포트가 삭제된 회사도 받는다(회신 "2026-10-19
    개정"). 그래서 삭제 회사 안내나 연결 진단 탭 보류를 두지 않는다.
  - 목록·마감 현황에서 들어오면 히스토리 state 의 병원 이름(settlementDetailLocation)을 먼저 제목에 쓴다 — 응답
    전(첫 로드)에도 이름으로 보인다. 새 탭으로 열면 응답의 이름을 기다린다.
  - 정산 탭에 저장하지 않은 항목 금액·메모가 있으면(useStatementReview 가 inject('settlementUnsavedInput') 로 dirty 를 알린다)
    병원·월을 바꾸거나 이 화면을 떠날 때 버릴지 묻는다. 탭만 바꾸는 이동은 묻지 않는다(KeepAlive 가 입력을 지킨다).
  - 탭은 쿼리 `tab` 에 둔다(없거나 모르는 값이면 정산). 탭 전환은 router.replace 로 `tab` 만 바꾼다 — 뒤로
    가기가 탭을 거치지 않고 목록으로 돌아간다. 월을 바꾸면 `month` 만 바꾸고 탭은 그대로 둔다.
  - 탭을 건너는 링크(예: 2-4 "이 병원 예외로 넣기" → 요율 탭 예외 모달, 대사 탭 → 정산 탭 경고)는
    'go-tab'(tab, intent?) 으로 온다. intent 는 { tab, type, payload, nonce } 로 두고 그 탭의 intent prop 에만
    넘기며, 탭이 'intent-done' 을 보내면 지운다.
  - 재수정(2-4) 확인창은 셸이 가진다 — 헤더와 정산 탭은 'open-reopen' 만 보낸다. 정산 탭에서는 곁 카드에 [재수정]이 있어
    헤더의 [재수정]을 숨긴다(showReopen). 헤더의 작은 '경고 n건'(누르면 정산 탭 경고 목록)도 정산 탭 밖에서만 보인다
    (showWarnings — 정산 탭에서는 마감 상태 패널이 목록을 보인다).
  - 정산 시작일 모달(SettlementStartModal)과 엑셀 내보내기 모달(SettlementExportModal — 목록과 같은 모달을 이 회사 1곳으로)도
    셸이 가진다. 헤더 칩·정산 탭 빈 상태 카드는 'open-start'({ cleanup }), 헤더 버튼은 'open-export' 만 보낸다. 시작일을
    저장하면 reload() 로 상세를 다시 받는다. 정산 탭의 쓰기가 409 SETTLEMENT_NOT_STARTED(화면이 낡아 시작 전 달에 쓰려 함)를
    받으면 provide('settlementOnNotStarted') 로 셸을 불러 안내 후 다시 받는다.
  - props canExport · canEditStart(기본 true — 라우트가 넘기지 않는다. 5단계 권한 숨김 자리)는 헤더에 넘기고 탭에는
    provide('settlementCan') 로 준다.
  - `?settlementMock=1`(운영 빌드 제외)이면 목 API 를 쓰고, 헤더의 접힌 'DEV 목 조작' 안에 `목 데이터` 배지와 마감 상태
    고르기·사용량 버튼을 보인다.

  요청 문서: ~/md/front/admin-콜봇-월정산-프론트요청.md "화면 명세 2", "요청 계약 2·4-2"
-->
<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>

    <!-- 페이지 헤더 영역 — 공통 헤더(모든 탭) -->
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <DetailHeader
          :company-id="companyId"
          :month="month"
          :company-name="companyName"
          :detail="currentDetail"
          :loading="loading"
          :mock="mock"
          :show-reopen="activeTab !== 'settle'"
          :show-warnings="activeTab !== 'settle'"
          :can-export="canExport"
          :can-edit-start="canEditStart"
          @change-month="changeMonth"
          @go-tab="goTab"
          @open-reopen="openReopen"
          @mock-change="reload"
          @open-start="openStart(false)"
          @open-export="openExport"
        />
      </div>
    </div>

    <!-- 콘텐츠 영역 — 탭 넷 -->
    <div class="px-0 pb-2">
      <div class="card content-wrap-card">
        <div class="detail-view">
          <nav class="detail-view__tabs" role="tablist" aria-label="월 정산 상세">
            <button
              v-for="t in DETAIL_TABS"
              :id="tabButtonId(t.key)"
              :key="t.key"
              :ref="(el) => setTabEl(t.key, el)"
              type="button"
              role="tab"
              class="detail-view__tab"
              :class="{ 'is-active': activeTab === t.key }"
              :aria-selected="activeTab === t.key ? 'true' : 'false'"
              :aria-controls="PANEL_ID"
              :tabindex="activeTab === t.key ? 0 : -1"
              @click="selectTab(t.key)"
              @keydown="onTabKeydown($event, t.key)"
            >
              {{ t.label }}
            </button>
          </nav>

          <!--
            병원·월마다 탭을 새로 마운트한다(묶음 키). 탭 사이 이동은 KeepAlive 가 상태를 지킨다 — KeepAlive 는 늘
            두므로, 상세가 없는 정산 탭으로 갔다 돌아와도 연결 진단 탭은 다시 마운트되지 않는다(리포트를 다시 안 부른다).
          -->
          <div
            :id="PANEL_ID"
            :key="viewKey"
            class="detail-view__body"
            role="tabpanel"
            :aria-labelledby="tabButtonId(activeTab)"
            :aria-busy="loading && activeTab !== 'diag' ? 'true' : 'false'"
          >
            <!--
              연결 진단은 정산 상세를 쓰지 않는다 — 상세 없이(받는 중·실패) 바로 연다.
              KeepAlive 안에는 주석을 두지 않는다(개발 빌드는 주석도 자식으로 센다 — 자식은 하나여야 한다).
            -->
            <KeepAlive>
              <DiagTab
                v-if="activeTab === 'diag'"
                key="diag"
                v-bind="tabProps"
                :intent="intentFor('diag')"
                @go-tab="goTab"
                @open-reopen="openReopen"
                @intent-done="onIntentDone('diag')"
              />
              <SettleTab
                v-else-if="currentDetail && activeTab === 'settle'"
                key="settle"
                v-bind="tabProps"
                :intent="intentFor('settle')"
                @go-tab="goTab"
                @open-reopen="openReopen"
                @open-start="(opts) => openStart(!!opts?.cleanup)"
                @intent-done="onIntentDone('settle')"
              />
              <RatesTab
                v-else-if="currentDetail && activeTab === 'rates'"
                key="rates"
                v-bind="tabProps"
                :intent="intentFor('rates')"
                @go-tab="goTab"
                @open-reopen="openReopen"
                @intent-done="onIntentDone('rates')"
              />
              <ReconTab
                v-else-if="currentDetail && activeTab === 'recon'"
                key="recon"
                v-bind="tabProps"
                :intent="intentFor('recon')"
                @go-tab="goTab"
                @open-reopen="openReopen"
                @intent-done="onIntentDone('recon')"
              />
            </KeepAlive>

            <!-- 정산·요율·대사 탭은 상세가 있어야 그린다 — 그 전에는 같은 패널 안에 상태를 보인다 -->
            <template v-if="activeTab !== 'diag' && !currentDetail">
              <!-- call-api 에 정산 라우트가 없는 환경(404 라우트 없음·501) — 목록과 같은 안내(info). 목 안내는 운영 빌드에서 빠진다 -->
              <a-alert
                v-if="loadError && loadError.kind === 'unimplemented'"
                type="info"
                show-icon
                :message="SETTLEMENT_UNIMPLEMENTED_TEXT"
              />

              <div v-else-if="loadError" class="detail-view__error" role="alert">
                <p class="detail-view__error-text">{{ loadError.message }}</p>
                <a-button v-if="loadError.retry" @click="retry">다시 시도</a-button>
              </div>

              <!-- 첫 로드 -->
              <a-skeleton v-else class="detail-view__skeleton" active :paragraph="{ rows: 8 }" />
            </template>
          </div>
        </div>
      </div>
    </div>

    <ReopenModal
      :open="reopenOpen"
      :company-id="companyId"
      :month="month"
      :company-name="companyName || companyId"
      :detail="currentDetail"
      :api="api"
      :reload="reload"
      @close="reopenOpen = false"
    />

    <SettlementStartModal
      :open="startOpen"
      :company-id="companyId"
      :month="month"
      :company-name="companyName || companyId"
      :api="api"
      :cleanup="startCleanup"
      @close="startOpen = false"
      @saved="onStartSaved"
      @open-month="onStartOpenMonth"
    />

    <SettlementExportModal
      v-if="exportCompanies.length"
      :open="exportOpen"
      :month="month"
      :companies="exportCompanies"
      :api="api"
      @close="exportOpen = false"
    />
  </div>
</template>

<script>
export default {
  name: 'SettlementDetail',
};
</script>

<script setup>
import { computed, provide, reactive, ref, watch } from 'vue';
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { Modal, message } from 'ant-design-vue';

import DetailHeader from './components/DetailHeader.vue';
import ReopenModal from './components/ReopenModal.vue';
import SettlementExportModal from './components/SettlementExportModal.vue';
import SettlementStartModal from './components/SettlementStartModal.vue';
import DiagTab from './components/tabs/DiagTab.vue';
import RatesTab from './components/tabs/RatesTab.vue';
import ReconTab from './components/tabs/ReconTab.vue';
import SettleTab from './components/tabs/SettleTab.vue';
import { resolveMonthParam } from './service/settlementFormat';
import {
  DEFAULT_DETAIL_TAB,
  DETAIL_TABS,
  SETTLEMENT_ROUTE_NAMES,
  companyNameFromState,
  resolveTabParam,
  statementStatusOf,
} from './service/settlementRules';
import { SETTLEMENT_UNIMPLEMENTED_TEXT, getSettlementApi, isSettlementMockEnabled } from './service/settlementMock';
import { NOT_STARTED_RELOAD_TEXT, settlementScopeView } from './service/settlementStart';
import {
  getCallApiErrorCode,
  getCallApiErrorStatus,
  isCallApiUnimplemented,
  parseCallApiError,
} from '@/views/Callbot/service/callApiError';

const props = defineProps({
  /** 상세 [엑셀 내보내기] — 라우트가 넘기지 않으면 true(5단계에서 권한 숨김 canByMode) */
  canExport: { type: Boolean, default: true },
  /** 정산 시작일 바꾸기(칩 버튼·빈 상태 카드 버튼) — 라우트가 넘기지 않으면 true(5단계) */
  canEditStart: { type: Boolean, default: true },
});

const LOAD_FALLBACK = '월 정산을 불러오지 못했습니다.';
const PANEL_ID = 'settlement-detail-panel';

const route = useRoute();
const router = useRouter();

// 목 스위치와 API 는 페이지를 열 때 한 번 정한다 — 탭·모달에도 같은 api 를 넘긴다
const mock = isSettlementMockEnabled();
const api = getSettlementApi();

// ---------------------------------------------------------------------------
// 라우트 — 병원은 경로, 달·탭은 쿼리
// ---------------------------------------------------------------------------

const companyId = computed(() => {
  const raw = route.params.companyId;
  const value = Array.isArray(raw) ? raw[0] : raw;
  return typeof value === 'string' ? value : '';
});
const month = computed(() => resolveMonthParam(route.query.month));
const activeTab = computed(() => resolveTabParam(route.query.tab));
const viewKey = computed(() => `${companyId.value}:${month.value}`);

// 다른 화면으로 떠나는 중에도 이 페이지의 watch 가 먼저 돌 수 있다 — 그때는 부르지 않는다
const isOnDetailRoute = () => route.name === SETTLEMENT_ROUTE_NAMES.detail && !!companyId.value;

function changeMonth(next) {
  if (!next || next === month.value) return;
  void router.replace({ query: { ...route.query, month: next } });
}

/** `tab` 만 바꾼다(정산은 쿼리에서 뺀다). 다른 쿼리(month 등)는 그대로 */
function switchTab(tab) {
  const key = resolveTabParam(tab);
  const wanted = key === DEFAULT_DETAIL_TAB ? undefined : key;
  if (route.query.tab === wanted) return;
  void router.replace({ query: { ...route.query, tab: wanted } });
}

// ---------------------------------------------------------------------------
// 정산 상세 — 이 페이지가 부르는 유일한 호출
// ---------------------------------------------------------------------------

const detail = ref(null);
// detail 이 어느 병원·월 것인지 — 지금 보는 병원·월과 다르면 쓰지 않는다
const detailKey = ref(null);
const loading = ref(false);
/** 상세가 없을 때의 실패 — { kind: 'unimplemented'|'invalid'|'error', message, retry } */
const loadError = ref(null);
// 월을 바꿔도 제목이 id 로 깜빡이지 않게, 받은 병원 이름을 기억해 둔다
const knownNames = reactive({});

const currentDetail = computed(() => (detailKey.value === viewKey.value ? detail.value : null));

const companyName = computed(() => {
  const name = currentDetail.value?.company_name || knownNames[companyId.value];
  if (name) return name;
  // 이름을 모르는 첫 로드 중에는 헤더가 자리표시를 보인다(null). 실패했으면 id
  return loading.value && !loadError.value ? null : companyId.value;
});

// 늦게 온 앞 응답이 새 응답을 덮지 않게 — 마지막 요청만 반영
let loadSeq = 0;
let latestLoad = Promise.resolve();

/** 지금 병원·월의 상세를 받는다. 실패는 안에서 처리하고 언제나 resolve 한다 */
function fetchDetail() {
  const seq = ++loadSeq;
  const id = companyId.value;
  const key = viewKey.value;
  loading.value = true;
  const promise = (async () => {
    try {
      const res = await api.getSettlement(id, month.value);
      if (seq !== loadSeq) return;
      if (!res || typeof res !== 'object') throw new Error('empty settlement detail');
      detail.value = res;
      detailKey.value = key;
      loadError.value = null;
      if (typeof res.company_name === 'string' && res.company_name) knownNames[id] = res.company_name;
    } catch (err) {
      if (seq !== loadSeq) return;
      handleLoadError(err, key);
    } finally {
      if (seq === loadSeq) loading.value = false;
    }
  })();
  latestLoad = promise;
  return promise;
}

function handleLoadError(err, key) {
  // 이미 이 병원·월 상세를 보이는 중(쓰기 뒤 다시 받기 등)이면 화면은 그대로 두고 알리기만 한다
  const showing = detailKey.value === key && !!detail.value;
  if (isCallApiUnimplemented(err)) {
    if (showing) message.error(SETTLEMENT_UNIMPLEMENTED_TEXT);
    else loadError.value = { kind: 'unimplemented', message: SETTLEMENT_UNIMPLEMENTED_TEXT, retry: false };
    return;
  }
  const text = parseCallApiError(err, LOAD_FALLBACK);
  // 형식 오류(400)는 다시 해도 같다 — 알리고, 상세가 없으면 다시 시도 없이 사유만 보인다
  const invalid = getCallApiErrorStatus(err) === 400 && getCallApiErrorCode(err) === 'VALIDATION_ERROR';
  if (invalid) message.warning(text);
  else if (showing) message.error(text);
  if (!showing) loadError.value = { kind: invalid ? 'invalid' : 'error', message: text, retry: !invalid };
}

/**
 * 탭·헤더·모달이 쓰기 뒤에 부른다(탭 인터페이스의 reload). 그 사이 더 새 요청이 시작됐으면 그것까지
 * 기다린다 — 기다린 쪽이 최신 상세를 보게. 언제나 resolve 한다.
 * @returns {Promise<void>}
 */
async function reload() {
  if (!isOnDetailRoute()) return;
  void fetchDetail();
  let pending;
  do {
    pending = latestLoad;
    await pending;
  } while (pending !== latestLoad);
}

function retry() {
  loadError.value = null;
  void fetchDetail();
}

// ---------------------------------------------------------------------------
// 탭 — 전환·키보드·탭을 건너는 intent
// ---------------------------------------------------------------------------

/** @type {import('vue').Ref<{ tab: string, type: string, payload: unknown, nonce: number }|null>} */
const intent = ref(null);
let intentSeq = 0;

const tabProps = computed(() => ({
  companyId: companyId.value,
  month: month.value,
  detail: currentDetail.value,
  detailLoading: loading.value,
  api,
  mock,
  reload,
}));

const intentFor = (tab) => (intent.value && intent.value.tab === tab ? intent.value : null);

/** 헤더·탭의 'go-tab' — 탭을 바꾸고, intent 가 있으면 그 탭에만 건다 */
function goTab(tab, next) {
  const key = resolveTabParam(tab);
  intent.value =
    next && next.type ? { tab: key, type: next.type, payload: next.payload ?? null, nonce: ++intentSeq } : null;
  switchTab(key);
}

function onIntentDone(tab) {
  if (intent.value && intent.value.tab === tab) intent.value = null;
}

/** 탭 바를 눌러 옮김 — 다른 탭에 걸어 둔 intent 는 버린다(나중에 그 탭을 열 때 엉뚱하게 실행되지 않게) */
function selectTab(tab) {
  if (intent.value && intent.value.tab !== tab) intent.value = null;
  switchTab(tab);
}

const tabButtonId = (tab) => `settlement-detail-tab-${tab}`;

const tabEls = {};
function setTabEl(tab, el) {
  if (el) tabEls[tab] = el;
  else delete tabEls[tab];
}

/** 탭 목록 키보드 — ←/→ 로 이웃 탭, Home/End 로 처음·끝 탭(WAI-ARIA tabs) */
function onTabKeydown(event, tab) {
  const keys = DETAIL_TABS.map((t) => t.key);
  const index = keys.indexOf(tab);
  let next = null;
  if (event.key === 'ArrowRight') next = keys[(index + 1) % keys.length];
  else if (event.key === 'ArrowLeft') next = keys[(index - 1 + keys.length) % keys.length];
  else if (event.key === 'Home') next = keys[0];
  else if (event.key === 'End') next = keys[keys.length - 1];
  if (!next) return;
  event.preventDefault();
  selectTab(next);
  tabEls[next]?.focus();
}

// ---------------------------------------------------------------------------
// 재수정(2-4) — 확정일 때만 연다
// ---------------------------------------------------------------------------

const reopenOpen = ref(false);

function openReopen() {
  if (statementStatusOf(currentDetail.value) !== 'confirmed') return;
  reopenOpen.value = true;
}

// 확정이 아니게 되면(목 상태 전환·다른 사람의 재수정 등) 열린 확인창을 닫는다
watch(
  () => statementStatusOf(currentDetail.value),
  (status) => {
    if (status !== 'confirmed') reopenOpen.value = false;
  }
);

// ---------------------------------------------------------------------------
// 정산 시작일 · 엑셀 내보내기 — 모달 둘은 셸이 가진다
// ---------------------------------------------------------------------------

const startOpen = ref(false);
/** [남은 정산서 지우기] — 날짜를 지금 값으로 고정하고 미리보기만 다시 */
const startCleanup = ref(false);
const exportOpen = ref(false);

/** 헤더 칩(cleanup false)·정산 탭 빈 상태 카드(남은 정산서면 cleanup true) */
function openStart(cleanup) {
  if (!props.canEditStart || !currentDetail.value) return;
  startCleanup.value = !!cleanup;
  startOpen.value = true;
}

/** 저장되면 상세를 다시 받는다 — 모달은 결과 안내가 있으면 연 채로 둔다 */
function onStartSaved() {
  void reload();
}

/** 미리보기 막힘·결과 안내의 [그 달 열기] — 모달을 닫고 그 달로(저장하지 않은 입력이면 셸이 묻는다) */
function onStartOpenMonth(next) {
  startOpen.value = false;
  changeMonth(next);
}

function openExport() {
  if (!props.canExport || !currentDetail.value) return;
  exportOpen.value = true;
}

/** 내보내기 모달에 넘길 회사 1곳 — 새 칸이 없는 응답이면 settlementScopeView 가 'in'·null 로 읽는다 */
const exportCompanies = computed(() => {
  const d = currentDetail.value;
  if (!d) return [];
  const scope = settlementScopeView(d);
  return [
    {
      company_id: companyId.value,
      company_name: companyName.value || companyId.value,
      settlement_scope: scope.scope,
      settlement_start_date: scope.startDate,
    },
  ];
});

provide('settlementCan', {
  canExport: computed(() => props.canExport),
  canEditStart: computed(() => props.canEditStart),
});

/** 정산 탭·재수정 모달의 쓰기가 409 SETTLEMENT_NOT_STARTED 를 받았다 — 화면이 낡았다. 알리고 다시 받는다 */
provide('settlementOnNotStarted', () => {
  message.warning({ content: NOT_STARTED_RELOAD_TEXT, key: 'SETTLEMENT_NOT_STARTED' });
  void reload();
});

// ---------------------------------------------------------------------------
// 저장하지 않은 입력 — 병원·월을 바꾸거나 이 화면을 떠나면 정산 탭에 입력한 금액·메모가 사라진다
// ---------------------------------------------------------------------------

/**
 * 정산 탭(useStatementReview)에 저장하지 않은 입력이 있는지. 정산 탭이 inject 해서 dirty 와 맞추고
 * 언마운트 때 false 로 둔다. KeepAlive 로 비활성일 때는 그대로 둔다 — 다른 탭에서 월을 바꿔도 묻게.
 */
const unsavedInput = ref(false);
provide('settlementUnsavedInput', unsavedInput);

// 확인창이 떠 있는 동안 또 이동하면(브라우저 뒤로 등) 같은 답을 기다린다 — 확인창이 겹쳐 남지 않게
let discardPrompt = null;

/**
 * 입력을 버리고 이동할지 묻는다.
 * @returns {Promise<boolean>} 버리고 이동이면 true, 계속 편집(취소·Esc)이면 false
 */
function confirmDiscard() {
  if (!discardPrompt) {
    discardPrompt = new Promise((resolve) => {
      Modal.confirm({
        title: '저장하지 않은 입력이 있습니다',
        content: '정산 탭에 입력한 금액·메모가 사라집니다. 이동할까요?',
        okText: '버리고 이동',
        okType: 'danger',
        cancelText: '계속 편집',
        // Enter 한 번에 입력을 버리지 않게 계속 편집에 초점을 둔다
        autoFocusButton: 'cancel',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    }).finally(() => {
      discardPrompt = null;
    });
  }
  return discardPrompt;
}

// 병원·월이 바뀌는 이동(월 선택·이번 달·지난 달·뒤로 가기)만 묻는다 — 탭만 바꾸는 이동은 그대로 보낸다
onBeforeRouteUpdate((to, from) => {
  const viewChanged =
    to.params.companyId !== from.params.companyId ||
    resolveMonthParam(to.query.month) !== resolveMonthParam(from.query.month);
  return viewChanged && unsavedInput.value ? confirmDiscard() : true;
});

// 이 화면을 떠나는 이동(경고 카드의 기본 요율 링크·요율 탭의 기본 요율 화면 링크·브레드크럼·← 병원 목록·사이드바)
onBeforeRouteLeave(() => (unsavedInput.value ? confirmDiscard() : true));

// ---------------------------------------------------------------------------
// 들어올 때와 병원·월이 바뀔 때 — 이전 병원·월의 상세·intent·재수정 창은 버리고 새로 받는다
// ---------------------------------------------------------------------------

watch(
  viewKey,
  () => {
    loadSeq += 1;
    loading.value = false;
    detail.value = null;
    detailKey.value = null;
    loadError.value = null;
    intent.value = null;
    reopenOpen.value = false;
    startOpen.value = false;
    exportOpen.value = false;
    // 목록·마감 현황이 히스토리 state 에 실어 보낸 이름 — 응답 전(첫 로드)에도 제목에 쓴다
    const fromState = companyNameFromState(window.history.state, companyId.value);
    if (fromState && !knownNames[companyId.value]) knownNames[companyId.value] = fromState;
    if (isOnDetailRoute()) void fetchDetail();
  },
  { immediate: true }
);
</script>

<style scoped lang="scss">
@use './styles/settlement' as *;

// ExtensionManage.vue 의 페이지 틀과 같은 값
.container-wrap {
  padding: 0 16px;
}

.content-wrap-card {
  padding: 16px;
}

.detail-view {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;

  // Underline tabs (mockup Detail.dc.html)
  &__tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    flex: none;
    border-bottom: 1px solid $st-border-strong;
  }

  &__tab {
    height: auto; // override the global button { height: 40px }
    margin-bottom: -1px;
    padding: 10px 16px;
    border: 0;
    border-bottom: 2px solid transparent;
    background: none;
    color: $st-text-secondary;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      color: $st-text;
    }

    &:focus-visible {
      outline: 2px solid $st-accent;
      outline-offset: -2px;
    }

    &.is-active {
      border-bottom-color: $st-text;
      color: $st-text;
      font-weight: 600;
    }
  }

  &__body {
    min-width: 0;
  }

  &__error {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 20px 24px;
    border: 1px solid $st-danger-border;
    border-radius: 12px;
    background: $st-danger-bg;
  }

  &__error-text {
    margin: 0;
    color: $st-danger;
    font-size: 13px;
    line-height: 1.6;
  }

  &__skeleton {
    padding: 8px 0;
  }
}
</style>
